// extracted by mini-css-extract-plugin
export default {"emptyDashboard":"EmptyContent_emptyDashboard__9JQGU","emptyImage":"EmptyContent_emptyImage__SQQRX","emptyMessage":"EmptyContent_emptyMessage__08nSI"};